// extracted by mini-css-extract-plugin
export default {"image":"zY-z","loaded":"AY-z"};